"use client"

import type { ReactNode } from "react"

import { cn } from "../lib/cn"

type EmptyStateProps = {
  icon?: ReactNode
  title: ReactNode
  children?: ReactNode
  compact?: boolean
  className?: string
}

export function EmptyState({ icon, title, children, compact, className }: EmptyStateProps) {
  return <div role="status" className={cn("flex flex-col items-center justify-center text-center", compact ? "gap-2 px-4 py-6" : "gap-3 px-6 py-12", className)}>{icon != null && <div className="text-muted-foreground [&_svg]:size-7">{icon}</div>}<div className="font-semibold text-foreground">{title}</div>{children != null && <div className="max-w-[46ch] text-[12.5px] leading-relaxed text-muted-foreground">{children}</div>}</div>
}
